export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-6 bg-gradient-to-br from-primary-600 to-primary-800 rounded-2xl p-6 md:p-10 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="relative z-10 flex-1 text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
              麻花影视 APP
            </h3>
            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-5">
              随时随地畅享高清影视，支持离线缓存、倍速播放、投屏观看。聚合多平台资源，一个 APP 解决所有观影需求。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-white text-primary-700 font-medium text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line"></i>
                下载 APP
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-white/15 text-white border border-white/20 font-medium text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line"></i>
                了解更多
              </a>
            </div>
          </div>
          <div className="relative z-10 w-40 h-40 md:w-48 md:h-48 flex-shrink-0 rounded-2xl overflow-hidden bg-white/10 flex items-center justify-center">
            <i className="ri-smartphone-line text-5xl md:text-6xl text-white/60"></i>
          </div>
        </div>
      </div>
    </section>
  );
}